import styled from 'styled-components';

export const SearchWrapper = styled.div`
  position: relative;
  width: 100%;
`;

export const ClearButton = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0;
  border: none;
  padding: 0;
  background-color: transparent;
  cursor: pointer;
`;
